import {
  FileViewerState,
  ICommentCategory,
  TSketchModalState
} from '@lifk/types'
import { defineStore } from 'pinia'
import { ref, Ref } from 'vue'

export const useModalStore = defineStore('modal', () => {
  const shareModalShowing = ref(false)
  const sketchDetailsModalState: Ref<TSketchModalState> = ref('closed')
  const siteDetailsModalShowing = ref(false)
  const budgetModalShowing = ref(false)
  const globalNavShowing = ref(false)
  const invalidVersionModalShowing = ref(false)
  const settingsModalShowing = ref(false)
  const editPasswordModalShowing = ref(false)
  const publicLinkBannerShowing = ref(false)
  const duplicateWorkshopModalShowing = ref(false)
  const commentCategoryModalShowing = ref(false)
  const commentCategoryModalData = ref<ICommentCategory | null>(null)
  const commentCategoryMenuReopening = ref(false)

  const fileViewerModalState = ref<FileViewerState>(new FileViewerState())

  const toggleShareModal = (show?: boolean) => {
    shareModalShowing.value = show ?? !shareModalShowing.value
  }

  return {
    shareModalShowing,
    sketchDetailsModalState,
    siteDetailsModalShowing,
    budgetModalShowing,
    globalNavShowing,
    toggleShareModal,
    fileViewerModalState,
    invalidVersionModalShowing,
    settingsModalShowing,
    editPasswordModalShowing,
    publicLinkBannerShowing,
    duplicateWorkshopModalShowing,
    commentCategoryModalShowing,
    commentCategoryModalData,
    commentCategoryMenuReopening
  }
})
